import { OPENING_MAP } from "./openings";
import type { AlbumType, Size } from "./types";

export function getArcSize(size: Size, albumType: AlbumType): string {
    const w = size.width;
    const h = size.height;

    if (albumType === "FPRINTS" || albumType === "HANDTORN") {
        return `${w}x${h}`;
    }

    return w < h ? `${w}x${h}` : `${h}x${w}`;
}

export function getOpenings(albumType: AlbumType, size: Size): string[] {
    const key = `${size.width}x${size.height}`;
    return OPENING_MAP[albumType]?.[key] ?? [];
}

export function getDefaultOpening(
    albumType: AlbumType,
    size: Size
): string | null {
    const list = getOpenings(albumType, size);

    return list.length > 0 ? list[0] : null;
}